import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IdentityVerificationStatus } from '@workspace/data-types';

@Component({
  selector: 'aura-identity-status',
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './identity-status.component.html',
  host: {
    class: 'inline-flex items-center justify-center',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdentityStatusComponent {
  status = input.required<IdentityVerificationStatus | undefined>();
  readonly Status = IdentityVerificationStatus;
}
